import React from 'react';

import './style.sass';

import CommonCircleList from '../../../../common-components/common-circle-list';
import ScrollAnimation from '../../../../../../../../core/ScrollAnimation';

let list = {
    colorNumber: '#7927E0',
    list: [
        'насколько полно изложена информация, отвечает ли контент требованиям клиентов?',
        'есть ли решение задачи на конкретной странице?',
        'есть ли уникальное предложение?',
        'сколько предложений (насколько полно и понятно изложена по ним информация)',
        'есть ответы на действительно важные вопросы на посадочных (что сделать, как сделать и тд)?',
        'хорошо ли развита структура сайта? Каждая ли посадочная страница соответствует конкретному запросу?',
    ],
};

let list2 = {
    colorNumber: '#7927E0',
    list: [
        'расширение и кластеризацию семантического ядра',
        'анализ выдачи в двух ПС (Яндекс и Google), формирование групп запросов, для которых нужна отдельная посадочная',
        'анализ посадочных конкурентов, формирование ТЗ на новые посадочные',
    ],
};
const SeoErrorsLanding = () => {
    return (
        <div className="errors-landing">
            <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                <div className="errors-landing__content">
                    <div className="errors-landing__header">
                        Отсутствие и/или низкое качество посадочных
                    </div>

                    <div className="errors-landing__blocks">
                        <div className="errors-landing__block-text">
                            <div className="errors-landing__text">
                                Мы проводим детальный анализ посадочных в сравнении с конкурентами
                                на соответствие метрик качества, отвечая на следующие вопросы:
                            </div>

                            <CommonCircleList CommonCircleList={list} />
                        </div>

                        <div className="errors-landing__block-img">
                            <img
                                src="/images/pic/seo-fintech/errors-landing.png"
                                alt="error"
                                loading="lazy"
                            />
                        </div>
                    </div>

                    <div className="errors-landing__subtitle">
                        Но довольно распространена ситуация, когда по части групп запросов (для
                        продвигаемой семантики) посадочные страницы отсутствуют вообще. Из-за этого
                        запросы ранжируются не целевой страницей и имеют позиции ниже, чем у
                        конкурентов.
                    </div>

                    <div className="errors-landing__text errors-landing__text_middle">
                        В качестве решения мы используем:
                    </div>

                    <CommonCircleList CommonCircleList={list2} />

                    <div className="errors-landing__text errors-landing__text_bottom">
                        А также разрабатываем ТЗ на контент для новых посадок, рекомендации по
                        перелинковке новых страниц. Внутренняя перелинковка сайта — это не только
                        соединение страниц ссылками, но и перераспределение ссылочного веса по
                        целевым страницам для поискового робота.
                    </div>

                    <div className="errors-landing__text">
                        Создание новых страниц улучшает ранжирование сайта по части запросов, а
                        также положительно повлияет на сайт в целом по ВЧ фразам за счет увеличения
                        количества тематических страниц на сайте.
                    </div>
                </div>
            </ScrollAnimation>
        </div>
    );
};

export default SeoErrorsLanding;
